export function className(
	...classNames: Array<string | undefined | null | { [key: string]: boolean }>
): { className: string } {
	const classes = [];
	for (const _className of classNames) {
		if (typeof _className === "object" && _className !== null) {
			for (const key in _className) {
				if (_className[key]) {
					classes.push(key);
				}
			}
		} else if (_className) {
			classes.push(_className);
		}
	}
	return { className: classes.join(" ") };
}
